import state from './moduleTrendDataReportState.js'
import mutations from './moduleTrendDataReportMutations.js'
import actions from './moduleTrendDataReportActions.js'
import getters from './moduleTrendDataReportGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}